import { fromJS, Map } from 'immutable';

export function request(state, action) {
    state = Map.isMap(state) ? state : fromJS(state);
    let items = state.get('items') || Map();
    return state.set('items', Map()).set('state', 'IN_PROGRESS');
}

export function error(state, action) {
    state = Map.isMap(state) ? state : fromJS(state);
    let items = state.get('items') || Map();

    state = state.set('state', 'ERROR')
                .set('errors', fromJS(action.errors));

    return state.set('items', items);
}

export function finish(state, action) {
    state = Map.isMap(state) ? state : fromJS(state);
    let { sports } = action,
        items = state.get('items');
    
    sports.forEach(sport => {
        items = items.set(sport.id, fromJS(sport));
    });

    return state.set('items', items).set('state', 'FINISHED');
}
